<template>
  <editor
    id="full-featured-non-premium"
    api-key="no-api-key"
    :init="config"
    :initialValue="initValue"
    v-model="content"
  />
</template>

<script>
import Editor from "@tinymce/tinymce-vue"
export default {
  components: {
    Editor
  },
  mounted() {
    this.content = this.isContent !== "" ? this.isContent : this.initValue
  },
  props: {
    isContent: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    config: {
      mode: "exact",
      language: "fr_FR",
      plugins:
        "preview importcss autosave save template table nonbreaking textpattern noneditable",
      // menubar: "",
      forced_root_block: "",
      force_br_newlines: false,
      force_p_newlines: false,
      toolbar:
        "undo redo | link image | bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align | forecolor backcolor | removeformat inserttable | cell row column | tableprops deletetable",
      content_style: [
        ".mce-content-body { margin: 0 !important } .mce-item-table td, .mce-item-table th { max-width: 100px; border-style: solid; } .mce-item-table th:first-of-type { border: none !inportant; } .mce-item-table th:not(:first-of-type) { background-color: #fbac2e; color: #fff } .mce-item-table tbody tr td:first-child,.mce-item-table tbody tr:first-child td  { background-color: #455aa9; color: #fff } .mce-item-table tbody tr td { background-color: #1b318677; color: #fff } "
      ],
      menu: {
        file: {
          title: "Fichier",
          items: "newdocument restoredraft | preview | print "
        },
        edit: {
          title: "Modifier",
          items: "undo redo | cut copy paste | selectall | searchreplace"
        },
        view: {
          title: "Vue",
          items:
            "code | visualaid visualchars visualblocks | spellchecker | preview fullscreen"
        },
        insert: {
          title: "Insertion",
          items:
            "image link media template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime"
        },
        format: {
          title: "Format",
          items:
            "bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align | forecolor backcolor | removeformat"
        },
        tools: {
          title: "Outils",
          items: "spellchecker spellcheckerlanguage | code wordcount"
        },
        table: {
          title: "Table",
          items: "inserttable | cell row column | tableprops deletetable"
        },
        help: { title: "Aide ?", items: "help" }
      },
      object_resizing: ":not(table)",
      table_toolbar: "",
      importcss_append: true,
      table_appearance_options: false,
      table_grid: false,
      height: 318,
      noneditable_noneditable_class: "mceNonEditable",
      toolbar_drawer: "sliding",
      table_resize_bars: false,
      inline_boundaries: false
    },
    content: ``,
    backUpValue: "",
    initValue: ``
  }),
  watch: {
    /* content(newVal) {
      // console.log(
      //   newVal ===
      //     `<!DOCTYPE html>↵<html>↵<head>↵</head>↵<body>↵↵</body>↵</html>`
      // )
      let formattedVal = newVal
        .replace("<!DOCTYPE html>", "")
        .replace("<html>", "")
        .replace("<head>", "")
        .replace("</head>", "")
        .replace("<body>", "")
        .replace("</body>", "")
        .replace("</html>", "")
        .trim()
      if (formattedVal === "") {
        this.content = this.backUpValue
      }
    } */
  }
}
</script>

<style lang="scss">
.tox-notifications-container,
.tox-statusbar {
  display: none !important;
}
</style>
